import accountConnect from '@handlebars/account-connect.hbs';
import accountMessage from '@handlebars/account-message.hbs';
import accountWelcome from '@handlebars/account-welcome.hbs';

import { setWindowTemplates } from '../Templates';

(() => {
    setWindowTemplates('account-connect', accountConnect);
    setWindowTemplates('account-message', accountMessage);
    setWindowTemplates('account-welcome', accountWelcome);
})();
